import { Injectable, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProviderParameters, BankDetailParameters } from '../models/ui/ProviderParameters';
import { Observable } from 'rxjs';
import { APISettings } from '../misc/settings';
import { AccountDetailsParameters } from '../models/ui/AccountDetailsParameters';

@Injectable({
  providedIn: 'root'
})

export class RegistrationService {

  constructor(private http: HttpClient) { }

  registerProvider(provider: ProviderParameters, captchaText: string,captchaId:string): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/providers/add/${captchaText}/${captchaId}`,
      provider, APISettings.httpOptions);
  }

  updateProvider(provider: ProviderParameters): Observable<string> {
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/providers/update`,
      provider, APISettings.httpOptions);
  }

  approveProvider(provider: ProviderParameters): Observable<string> {
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/providers/approve`,
      provider, APISettings.httpOptions);
  }

  rejectProvider(provider: ProviderParameters): Observable<string> {
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/providers/reject`,
      provider, APISettings.httpOptions);
  }

  suspendProvider(provider: ProviderParameters): Observable<string> {
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/providers/suspend`,
      provider, APISettings.httpOptions);
  }

  unsuspendProvider(provider: ProviderParameters): Observable<string> {
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/providers/unsuspend`,
      provider, APISettings.httpOptions);
  }

  updateBankInfo(bank: BankDetailParameters): Observable<string> {
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/bank/update`,
      bank, APISettings.httpOptions);
  }

  updateAccountDetails(account: AccountDetailsParameters): Observable<string> {
    return this.http.put<string>(`${APISettings.apiBaseAddress}/api/account/update`,
      account, APISettings.httpOptions);
  }
  generateCaptcha(id: string): Observable<ArrayBuffer> {
    const url = `${APISettings.apiBaseAddress}/api/Captcha/getCaptcha/${id}`;
    return this.http.get(url, { responseType: 'arraybuffer' });
  }
}